import React from 'react'
import Navbar from './Navbar'
import DesktopMenu from './Menu/DesktopMenu'

const Header = () => {
  return (
    <header>
        <Navbar />
        <DesktopMenu/>   
          
    </header>
  )
}

export default Header
